var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_196_1",
    "data-name": "Component 196 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#d7dce2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "android",
    transform: "translate(-18.928 5.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(27.428 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M113.829,155.433v27.694c0,2.163,1.3,3.86,3.525,3.86h2.906a2.139,2.139,0,0,0-.324,1.094v7.844a4.089,4.089,0,0,0,8.143,0v-7.844a2.015,2.015,0,0,0-.49-1.094h7.088a2.014,2.014,0,0,0-.492,1.094v7.844a4.089,4.089,0,0,0,8.143,0v-7.844a2.14,2.14,0,0,0-.323-1.094h2.91c2.226,0,3.52-1.7,3.52-3.86V155.433H113.829Z",
    transform: "translate(-102.633 -135.657)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M31.5,158.977a4,4,0,0,0-4.071,3.712v15.894a4.089,4.089,0,0,0,8.143,0V162.69A4,4,0,0,0,31.5,158.977Z",
    transform: "translate(-27.428 -138.75)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M138.024,5.351l.71-1.042.711-1.03L141.031.963a.6.6,0,0,0-.176-.858.639.639,0,0,0-.878.173L137.557,3.8l-.728,1.062a21.827,21.827,0,0,0-15.135,0L120.971,3.8l-.716-1.041L118.556.28a.65.65,0,0,0-.885-.173.611.611,0,0,0-.177.858l1.584,2.317.711,1.031.715,1.039c-5.4,2.448-9.052,7.3-9.052,12.388h35.62C147.072,12.651,143.42,7.8,138.024,5.351Zm-16.4,7.448a1.857,1.857,0,1,1,1.908-1.859A1.882,1.882,0,0,1,121.629,12.8Zm15.268,0a1.857,1.857,0,1,1,1.908-1.859A1.884,1.884,0,0,1,136.9,12.8Z",
    transform: "translate(-100.761 0)",
    fill: "#57c927"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M31.681,197.633c-1.587,0-3.235-1.5-4.253-3.872v15.181a4.089,4.089,0,0,0,8.143,0v-14.39C34.553,196.46,33.081,197.633,31.681,197.633Z",
    transform: "translate(0 -169.108)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M415.5,158.977a4,4,0,0,0-4.071,3.712v15.894a4.089,4.089,0,0,0,8.143,0V162.69A4,4,0,0,0,415.5,158.977Z",
    transform: "translate(-335.143 -138.75)",
    fill: "#57c927"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(38.119 9.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M415.681,197.633c-1.587,0-3.235-1.5-4.253-3.872v15.181a4.089,4.089,0,0,0,8.143,0v-14.39C418.553,196.46,417.081,197.633,415.681,197.633Z",
    transform: "translate(-373.261 -178.139)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M132.732,163.872c-8.051,0-15.268-.931-17.3-2.254v26.906c0,2.163,1.3,3.86,3.525,3.86h2.906a2.139,2.139,0,0,0-.324,1.094v7.844a4.089,4.089,0,0,0,8.143,0v-7.844a2.015,2.015,0,0,0-.49-1.094h7.088a2.014,2.014,0,0,0-.492,1.094v7.844a4.089,4.089,0,0,0,8.143,0v-7.844a2.14,2.14,0,0,0-.323-1.094h2.91c2.226,0,3.52-1.7,3.52-3.86V161.617C148,162.939,140.784,163.872,132.732,163.872Z",
    transform: "translate(-114.922 -150.085)",
    fill: "#1cb71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M138.805,72.885a1.91,1.91,0,0,1-3.819,0,1.819,1.819,0,0,1,.653-1.388,39.364,39.364,0,0,0-12.756,0,1.815,1.815,0,0,1,.654,1.388,1.91,1.91,0,0,1-3.818,0,1.816,1.816,0,0,1,.159-.739,23.084,23.084,0,0,0-7.652,3.411,13.506,13.506,0,0,0-.775,4.129h35.62a13.515,13.515,0,0,0-.774-4.127,23.043,23.043,0,0,0-7.65-3.415A1.844,1.844,0,0,1,138.805,72.885Z",
    transform: "translate(-111.452 -70.977)",
    fill: "#1cb71c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M132.732,238.331c-6.857,0-13.232-1.353-17.3-3.57v17.6c0,2.163,1.3,3.86,3.525,3.86h2.906a2.139,2.139,0,0,0-.324,1.094v7.844a4.089,4.089,0,0,0,8.143,0v-7.844a2.015,2.015,0,0,0-.49-1.094h7.088a2.014,2.014,0,0,0-.492,1.094v7.844a4.089,4.089,0,0,0,8.143,0v-7.844a2.14,2.14,0,0,0-.323-1.094h2.91c2.226,0,3.52-1.7,3.52-3.86v-17.6C145.964,236.979,139.589,238.331,132.732,238.331Z",
    transform: "translate(-76.804 -204.892)",
    fill: "#049e42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidLogo);
export default __webpack_public_path__ + "static/media/androidLogo.531f8bb1ca5fc2b176f7884010a11db4.svg";
export { ForwardRef as ReactComponent };